import axios from "axios";

const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

export const fetchTaskCounterSubmissionList = async (data: any) => {
  return axios.post(`${baseTaskUrl}/TaskCounterSubmission/get-list`, data);
};

export const fetchTaskCounterByDate = async (workDate: string) => {
  return axios.get(`${baseTaskUrl}/TaskCounterSubmission/by-date?workDate=${workDate}`);
};

export const fetchTaskCounterUserTemplates = async () => {
  return axios.get(`${baseTaskUrl}/TaskCounterSubmission/templates`);
};

export const fetchUpsertTaskCounterSubmission = async (data: any) => {
  return axios.post(`${baseTaskUrl}/TaskCounterSubmission/upsert`, data);
};

export const fetchDeleteTaskCounterSubmission = async (id: number) => {
  return axios.delete(`${baseTaskUrl}/TaskCounterSubmission/${id}`);
};
